module.exports = __webpack_public_path__ + "static/media/Community.c5c6c146.svg";